import DocumentConstructor from "./DocumentConstructorContainer";

export default DocumentConstructor;
